import React, { Component } from "react";
import Cookies from 'js-cookie';
import queryString from 'query-string';
import { BrowserRouter, Route, Switch } from "react-router-dom";
import 'react-notifications/lib/notifications.css';

import Warning from "./loginService/warning";
import Login from "./loginService/login";
import Logout from "./loginService/logout";
import Home from "./home";


const getUserFromData = data => {
  if (data) {
    try {
      return JSON.parse(atob(data));
    } catch (error) {
      // ignore
    }
  }
  return null;
};


class App extends Component {

  constructor(props) {
    super(props);
    this.state = {
      portal: '',
      jwt: Cookies.get('jwt')
    }

    this.setSession = this.setSession.bind(this)
    this.renderRedirect = this.renderRedirect.bind(this)
    this.checkRedirect();

  }

  // componentDidMount() {
  //   this.checkRedirect();
  // }

  setSession = (user) => {

    // console.log(user.reserve_admin)
    sessionStorage.setItem('id_e', user.EmployeeId);
    sessionStorage.setItem('id_s', user.StaffId);
    sessionStorage.setItem('name', user.Name);
    sessionStorage.setItem('email', user.email);
    sessionStorage.setItem('int', 'refresh');

    if (user.reserve_staff === true) {
      sessionStorage.setItem('staff', true);
    }

    if (user.reserve_admin === true) {
      sessionStorage.setItem('admin', true);
    }

    if (user.super_admin === true) {
      sessionStorage.setItem('admin', true);
      sessionStorage.setItem('super', true);
    }

  }


  renderRedirect() {

    var id = sessionStorage.getItem('id_e');
    var path;
    var admin = sessionStorage.getItem('admin');
    var super_ = sessionStorage.getItem('super');

    if (admin === 'true' || super_ === 'true') {
      path = '/' + id + '/home';
      sessionStorage.setItem('version', 'desktop')
    }
    else {
      path = '/warning';
    }

    this.props.history.push(path);
  }


  checkRedirect = _ => {

    const values = queryString.parse(this.props.location.search);

    // console.log('values', values)

    if (Object.keys(values).length > 0) { // Just login

      // Cookies.set('jwt', values.token);
      // console.log('first time login')
      // Cookies.get('jwt');

      var data = values.data;
      var user = getUserFromData(data).user

      this.setSession(user);
      this.renderRedirect();

    }

    else {

      let intention = sessionStorage.getItem('int');
      let id_e = sessionStorage.getItem('id_e');

      if (intention === 'logout') {
        // console.log('logout')
        this.props.history.push('/logout');
      }

      else if (id_e !== undefined && id_e !== null) {
        this.renderRedirect();
      }

      else {
        // console.log('login');
        this.props.history.push('/login')
      }

    }

  }

  render() {

    return (
      <div className="App">
        <div className="content">
          <BrowserRouter>

            <Switch>

              <Route exact path="/:employee_id/home" component={Home} />
              <Route exact path="/logout" component={Logout} />
              <Route exact path="/login" component={Login} />
              <Route exact path="/warning" component={Warning} />

            </Switch>
          </BrowserRouter>

        </div>

      </div>
    )
  }

}

export default App;
